import React from "react";
import {MedicationV2} from "../../types";
import MedicationCardTitle from "../medication-card/medication-card-title";
import MedicationCardAttributes from "../medication-card/medication-card-attributes";
import MedicationCardOptions from "./medication-options-card";

export interface MedicationCardV2Props {
    medication: MedicationV2;
}

const MedicationCardV2 = ({medication}: MedicationCardV2Props) => {
    return (
        <pui-card class="medication-card" spacingleft="med-small" spacingright="med-small" fullWidth>
            <MedicationCardTitle {...medication.medicationInfo} />
            <MedicationCardAttributes medicationIntake={medication.medicationIntake}
                                      attributes={medication.medicationAttributes}/>
            <MedicationCardOptions medication={medication}/>
        </pui-card>
    );
}

export default MedicationCardV2;
